<template>
  <div class="blog-page blog-page-posts-show">
    <SfBreadcrumbs class="breadcrumbs desktop-only container-xl" :breadcrumbs="breadcrumbs">
      <template #link="{breadcrumb}">
        <router-link :to="breadcrumb.route.link" class="sf-breadcrumbs__breadcrumb">
          {{ breadcrumb.text }}
        </router-link>
      </template>
    </SfBreadcrumbs>

    <div v-if="post">
      <div class="blog-page--hero">
        <div class="container-lg">
          <div class="logo">
            <SfImage src="/assets/custom/logos/logo-ruckzuck-ratgeber-badge-dark.png" />
          </div>

          <h1 class="blog-page--page-title" v-html="post.title" />

          <!--<h3 class="blog-page--page-date blog-page--preview-date">
            {{ post.date | prettyDate }}
          </h3>-->
        </div>
      </div>

      <div class="container" v-if="getPostImage(post)">
        <div class="blog-page--preview-large blog-page--preview-large-hero-merge">
          <SfImage :src="getPostImage(post)" />
        </div>
      </div>

      <div class="blog-page--post-container">
        <div class="container-lg">
          <div v-html="post.content">
            &nbsp;
          </div>
        </div>

        <!--<div class="container">
          <router-link :to="localizedRoute(`/posts`)" class="link blog-page--preview-link">
            Back to posts
          </router-link>
        </div>-->
      </div>

      <!--<div class="blog-page--entries" v-if="relatedPosts">
        <div class="container">
          <h2>
            Related Posts
          </h2>

          <div class="row row--entries">
            <div class="col col-md-6 col-lg-4" v-for="(post) in relatedPosts" :key="post.id">
              <div class="blog-page--preview-small">
                <router-link :to="localizedRoute(`/posts/${post.slug}`)" class="blog-page--preview-small-bg" :style="getPostImage(post)">
                  &nbsp;
                </router-link>

                <div class="blog-page--preview-small-inner">
                  <h4 class="blog-page--preview-date">
                    {{ post.date | prettyDate }}
                  </h4>

                  <h3 class="blog-page--preview-title">
                    <router-link :to="localizedRoute(`/posts/${post.slug}`)" v-html="post.title" />
                  </h3>

                  <p class="blog-page--preview-excerpt" v-html="$options.filters.truncate( post.excerpt, 175, '...' )">&nbsp;</p>

                  <router-link :to="localizedRoute(`/posts/${post.slug}`)" class="blog-page--preview-link">
                    Learn More&nbsp;<span class="slide-right">&rtrif;</span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>-->
    </div>

    <div v-else>
      <h2>
        No post found.
      </h2>
    </div>

    <hr class="divider container-xl">

    <MSectionUsp />

    <MSectionNewsletter />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import i18n from '@vue-storefront/i18n';
import { getPostImage, plainSeoText, publicPostsUrl, seoMetaInfo } from '../../helpers/index'
import MSectionUsp from 'theme/components/molecules/m-section-usp';
import MSectionNewsletter from 'theme/components/molecules/m-section-newsletter';
import { SfImage,
  SfBreadcrumbs
} from '@storefront-ui/vue';

export default {
  name: 'PostsShow',
  components: {
    MSectionUsp,
    MSectionNewsletter,
    SfBreadcrumbs,
    SfImage
  },
  serverPrefetch () {
    return this.fetchPost()
  },
  computed: {
    ...mapGetters({
      post: 'wordpress/currentPost'
    }),
    relatedPosts () {
      return null
    },

    breadcrumbs () {
      return [
        { text: i18n.t('ruckzuck.store'), route: { link: this.localizedRoute('/') } },
        { text: i18n.t('Ratgeber'), route: { link: this.localizedRoute('/posts') } },
        { text: this.post ? this.post.title : '' }
      ];
    },
    currentRoute () {
      return {
        ...this.navigation.find(navigation => this.localizedRoute(navigation.link) === this.$route.path)
      };
    }
  },
  filters: {
    prettyDate: function (date) {
      let newDate = new Date(date)
      let dateFormat = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
      return newDate.toLocaleDateString('en-GB', dateFormat)
    }
  },
  // Client-side only
  watch: {
    '$route.params.slug' (slug) {
      if (slug) {
        this.fetchPost()
      }
    }
  },
  mounted () {
    if (!this.post || this.post.slug !== this.$route.params.slug) {
      this.fetchPost()
    }
  },
  metaInfo () {
    if (!this.post) {
      return {}
    }

    const title = plainSeoText(this.post.seo && this.post.seo.title) || plainSeoText(this.post.title)
    const description = plainSeoText(this.post.seo && this.post.seo.metaDesc) || plainSeoText(this.post.excerpt)

    return seoMetaInfo({
      title,
      description,
      url: publicPostsUrl(this.post.slug),
      image: this.getPostImage(this.post),
      type: 'article'
    })
  },
  methods: {
    fetchPost () {
      return this.$store.dispatch('wordpress/loadPost', { slug: this.$route.params.slug })
    },
    getPostImage (post) {
      return getPostImage(post)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../blog/scss/blog';
  @import './scss/post';
</style>
